import { studentBookingClient } from '../client';
import { StudentBookingSuccessResponse } from '../types';

import {
    GetValidTaxIdProcessSuccessResponse,
    GetUserHasBookingsSuccessResponse,
    GetUserHasSpanishTaxInfoSuccessResponse,
} from './types';
import { UserServiceApiEndpoints } from './constants';
import { SetUserPasswordUsingPinDto } from './dto/SetUserPasswordUsingPin.dto';

export const SetUserPasswordUsingPin = async (details: SetUserPasswordUsingPinDto) => {
    const { data: response } = await studentBookingClient.post<
        StudentBookingSuccessResponse<boolean>
    >(UserServiceApiEndpoints.SET_PASSWORD_USING_PIN, details);

    return response.data;
};

export const validateTaxId = async (taxId: string) => {
    const { data: response } = await studentBookingClient.get<GetValidTaxIdProcessSuccessResponse>(
        UserServiceApiEndpoints.VALIDATE_TAX_ID.replace('{taxId}', taxId)
    );

    return response.data;
};

export const userHasBookings = async () => {
    const { data: response } = await studentBookingClient.get<GetUserHasBookingsSuccessResponse>(
        UserServiceApiEndpoints.USER_HAS_BOOKINGS
    );

    return response.data;
};

export const getUserSpanishTaxInfo = async () => {
    const { data: response } =
        await studentBookingClient.get<GetUserHasSpanishTaxInfoSuccessResponse>(
            UserServiceApiEndpoints.SPANISH_TAX_INFO
        );

    return response.data;
};
